/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Device_ApisInputs */

const en_svchip_device_apis = /** @type {(inputs: Svchip_Device_ApisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Device APIs`)
};

const ar_svchip_device_apis = /** @type {(inputs: Svchip_Device_ApisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`واجهات الأجهزة`)
};

const bn_svchip_device_apis = /** @type {(inputs: Svchip_Device_ApisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডিভাইস API`)
};

const de_svchip_device_apis = /** @type {(inputs: Svchip_Device_ApisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geräte-APIs`)
};

const es_svchip_device_apis = /** @type {(inputs: Svchip_Device_ApisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API de dispositivo`)
};

const fr_svchip_device_apis = /** @type {(inputs: Svchip_Device_ApisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API de l'appareil`)
};

const pt_svchip_device_apis = /** @type {(inputs: Svchip_Device_ApisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APIs de dispositivos`)
};

const zh_svchip_device_apis = /** @type {(inputs: Svchip_Device_ApisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设备 API`)
};

const tr_svchip_device_apis = /** @type {(inputs: Svchip_Device_ApisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cihaz API'leri`)
};

const ru_svchip_device_apis = /** @type {(inputs: Svchip_Device_ApisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-интерфейсы устройств`)
};

const pl_svchip_device_apis = /** @type {(inputs: Svchip_Device_ApisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interfejsy API urządzenia`)
};

/**
* | output |
* | --- |
* | "Device APIs" |
*
* @param {Svchip_Device_ApisInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_device_apis = /** @type {((inputs?: Svchip_Device_ApisInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Device_ApisInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_device_apis(inputs)
	if (locale === "bn") return bn_svchip_device_apis(inputs)
	if (locale === "de") return de_svchip_device_apis(inputs)
	if (locale === "es") return es_svchip_device_apis(inputs)
	if (locale === "fr") return fr_svchip_device_apis(inputs)
	if (locale === "pt") return pt_svchip_device_apis(inputs)
	if (locale === "zh") return zh_svchip_device_apis(inputs)
	if (locale === "tr") return tr_svchip_device_apis(inputs)
	if (locale === "ru") return ru_svchip_device_apis(inputs)
	if (locale === "pl") return pl_svchip_device_apis(inputs)
	return en_svchip_device_apis(inputs)
});